// @flow
import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import MuiDialogHeader from "./MuiDialogHeader";

const styles = (theme: DictionaryType): DictionaryType => ({
  modalConent: {
    marginTop: "70px"
  }
});

type GeneralModalFormClassesType = {
  modalConent: DictionaryType
};

type GeneralModalFormPropsType = {
  classes: GeneralModalFormClassesType,
  open: boolean,
  handleModalStatus: Function,
  title: string,
  form: React$Element<*>,
  maxMd?: boolean,
  maxLg?: boolean,
  fullScreen?: boolean,
  notFullWidth?: boolean
};

class GeneralModalForm extends Component<GeneralModalFormPropsType, *> {
  handleClickOpen = () => {
    this.props.handleModalStatus(true);
  };

  handleRequestClose = () => {
    this.props.handleModalStatus(false);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <Dialog
        disableBackdropClick
        fullWidth={this.props.notFullWidth ? false : true}
        maxWidth={this.props.maxLg ? "lg" : this.props.maxMd ? "md" : "sm"}
        fullScreen={this.props.fullScreen}
        open={this.props.open}
        onClose={this.handleRequestClose}
      >
        <MuiDialogHeader
          onClose={this.handleRequestClose}
          title={this.props.title}
        />
        <DialogContent
          className="mui-form"
          classes={{ root: classes.modalConent }}
        >
          {this.props.form}
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(GeneralModalForm);
